<!--
  Componente genérico para mostrar el listado de emails de diferentes entidades.
  
  Props:
  - filterValue: El valor a filtrar (ID o código de la entidad)
  - entityType: Tipo de entidad ('tarea', 'pedido', 'oferta', 'oportunidad', 'factura')
  - filterName: (Opcional) Nombre específico del campo a filtrar. Si no se proporciona, usa el mapeo por defecto.
  
  Mapeo automático de filtros por entityType:
  - tarea: 'datos##codigoTarea'
  - pedido: 'datos##codigoPedido'
  - oferta: 'datos##codigoOferta'
  - oportunidad: 'datos##codigoOportunidad'
  - factura: 'datos##idFactura'
  
  Ejemplos de uso:
  
  Para tareas:
  <listado-mails 
    :filterValue="codigoTarea" 
    entityType="tarea"
    @listado-cerrado="verListadoMails = false"
  />
  
  Para facturas:
  <listado-mails 
    :filterValue="idFactura" 
    entityType="factura"
    @listado-cerrado="verListadoMails = false"
  />
  
  Con filtro personalizado:
  <listado-mails 
    filterName="datos##customField"
    :filterValue="customValue" 
    entityType="pedido"
    @listado-cerrado="verListadoMails = false"
  />
-->
<template>
  <!-- <f7-popup tablet-fullscreen ref="popupVerEmails" class="popup-ver-emails" v-if="popupOpened" :opened="true"  @popup:close="onPopupClosed" swipe-to-close> -->
  <f7-popup 
    tablet-fullscreen
    ref="popupListadoEmail"
    class="popup-listado-email"
    :opened="true"
    @popup:opened="onPopupOpened"
    @popup:closed="onPopupClosed"
    swipe-to-close
  >
    <f7-page>
      <f7-navbar :title="getTitle()">
        <f7-nav-right></f7-nav-right>
      </f7-navbar>
      <f7-card
        class="elevation-3 padding-vertical-half padding-right"
      >
      <!-- rList Table CARD-->
        <r-dynamic-list
          ref="rlist"
          :dbAdapter="RegistroEmail"
          :tableCode="'REGISTROEMAILTABS'"
          :primary="['id']"
          :tableMode="true"
          :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
          class="card full-height data-table"
          classContent="card-content full-height"
          :shownFields="['datos']"
          :massiveActions="false"
          :mandatoryFilter ="getFilter()"
          :funcShowCheck="_ => {return false;}"
          :controlsWidth="45"
          :searchOnInit="true"
          useView="vista_RegistroEmails"
        >
          <template v-slot:optionsColumn="{item}">
            <f7-link icon-f7="eye" color="green" external :href="getEmailUrl(item)"></f7-link>
          </template>
        </r-dynamic-list>
      </f7-card>
    </f7-page>
  </f7-popup>
</template>
<style scoped>
</style>
<script>
import rDynamicList from "./rDynamicList.vue";
import RegistroEmail from "./../js/db/RegistroEmail.js";

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      RegistroEmail,
      popupOpened: false,
    };
  },
  props: {
    filterName: {
      type: String,
      default: ""
    },
    filterValue: {
      type: String,
      default: null
    },
    entityType: {
      type: String,
      default: "tarea",
      validator: function (value) {
        return ['tarea', 'pedido', 'oferta', 'oportunidad', 'factura'].includes(value)
      }
    }
  },
  computed: {
    entityDisplayName() {
      const entityNames = {
        'tarea': 'tarea',
        'pedido': 'pedido',
        'oferta': 'oferta',
        'oportunidad': 'oportunidad',
        'factura': 'factura'
      };
      return entityNames[this.entityType] || 'elemento';
    }
  },
  methods: {
    getTitle() {
      const self = this;
      return `Emails de la ${self.entityDisplayName} ${self.filterValue}`;
    },
    getFilter() {
      const self = this;
      // Si se proporciona un filterName específico, usarlo (formato simple para compatibilidad)
      if (self.filterName) {
        return {
          [self.filterName]: self.filterValue
        };
      }
      
      // Usar el mapeo por defecto según el tipo de entidad con la operación correcta
      const filterMapping = {
        'tarea': { field: 'datos.codigoTarea', operation: 'EQUALS_IGNORE_CASE' },
        'pedido': { field: 'datos.codigoPedido', operation: 'EQUALS_IGNORE_CASE' },
        'oferta': { field: 'datos.codigoOferta', operation: 'EQUALS_IGNORE_CASE' },
        'oportunidad': { field: 'datos.codigoOportunidad', operation: 'EQUALS_IGNORE_CASE' },
        'factura': { field: 'datos.idFactura', operation: 'EQUALS_IGNORE_CASE' }
      };
      
      const config = filterMapping[self.entityType] || { field: 'datos.codigo', operation: 'EQUALS_IGNORE_CASE' };
      
      return {
        historificar: true,
        andList: [{
          historificar: true,
          nombre: config.field,
          valor: self.filterValue,
          operacion: config.operation
        }]
      };
    },
    getEmailUrl(item) {
      const self = this;
      var currentUrl = new URL(window.location.href);
      return currentUrl.pathname + ('#!/' + `registroemail/view/${item.id}/`);
    },
    onPopupOpened: function(e) {
      var self = this;
      var app = self.$f7;
      self.popupOpened = true;
      this.$emit('listado-abierto', true);
    },
    onPopupClosed: function(e) {
      var self = this;
      var app = self.$f7;
      this.$emit('listado-cerrado', true);

    },
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
  }
};
</script>